import { FavorLogo } from './Icons'
import { styled } from 'styled-components'
import { mediaDesktop, mediaMobile } from './styles/breakPoints'

const Logo = styled(FavorLogo)`
  position: fixed;
  left: 30px;
  bottom: 30px;
  ${mediaMobile} {
    display: none;
  }
`

const Main = styled.div`
  ${mediaDesktop} {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    width: 30rem;
    overflow: hidden;
  }
`

const Image = styled.div`
  ${mediaDesktop} {
    background-image: url(/images/bg-photo.jpg);
    background-size: cover;
    background-position: center center;
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 30rem;
  }
`

const PageContainer = ({ className = undefined, children, includeImages = true }) => (
  <>
    {includeImages ? <Image /> : null}
    <Main className={className}>
      {includeImages ? <Logo /> : null}
      {children}
    </Main>
  </>
)

export default PageContainer
